// src/sections/SteamedDishes/SteamedDishes.js
import React from 'react';
import styles from './SteamedDishes.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import de FontAwesomeIcon
import { faHeart as solidHeart } from '@fortawesome/free-solid-svg-icons'; // Import du cœur plein
import { faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons'; // Import du cœur vide

const steamedDishesData = [
  { id: "steamed-shrimp-bites", name: "BOUCHÉES CREVETTES 4PCS", price: "3.50€" },
  { id: "steamed-chicken-bites", name: "BOUCHÉES POULET 4PCS", price: "3.50€" }
];

// Le composant reçoit maintenant les props favorites, addFavorite, removeFavorite
const SteamedDishes = ({ id, favorites, addFavorite, removeFavorite }) => {
  
  // Fonction pour vérifier si un article est déjà dans les favoris
  const isFavorite = (item) => {
    return favorites.some(favItem => favItem.id === item.id);
  };

  // Fonction pour gérer le clic sur le bouton favoris
  const handleFavoriteClick = (item) => {
    if (isFavorite(item)) {
      removeFavorite(item.id);
    } else {
      addFavorite(item);
    }
  };

  return (
    <section id={id} className={styles.steamedDishes}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>NOS VAPEURS</h2>
        <div className={styles.menuList}>
          {steamedDishesData.map((item) => ( // Utilisation de item.id comme clé
            <div key={item.id} className={styles.menuItem}>
              <span className={styles.itemName}>{item.name}</span>
              <span className={styles.itemSeparator}></span>
              
              {/* NOUVEAU WRAPPER POUR LE PRIX ET LE BOUTON FAVORIS */}
              <div className={styles.priceAndFavorite}>
                <span className={styles.itemPrice}>{item.price}</span>
                <button
                  className={`${styles.favoriteButton} ${isFavorite(item) ? styles.isFavorite : ''}`}
                  onClick={() => handleFavoriteClick(item)}
                  aria-label={isFavorite(item) ? `Retirer ${item.name} des favoris` : `Ajouter ${item.name} aux favoris`}
                >
                  <FontAwesomeIcon icon={isFavorite(item) ? solidHeart : regularHeart} />
                </button>
              </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SteamedDishes;